import { mainHomeSettingState } from '@atom/setting/homeSettingState';
import { useRecoilValue } from 'recoil';

function useMainHomeSetting() {
  return useRecoilValue(mainHomeSettingState);
}

export default useMainHomeSetting;
